export default __webpack_public_path__ + "static/media/certificateMedium.0ed04bdb.webp";